import { DATE_FORMATS, DateInput, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import { useSelectedAppLanguage } from '@/hooks/company/useSelectedAppLanguage';
import { FIELD_BORDER } from '@/pages/ThematicMeetings/components/meetingStyles';
import { toContentLanguage } from '@/utils/contentLanguage';

export const SCHEDULED_AT_INPUT_TEST_ID = 'new-meeting-date-input';

/** The date and time panel of the field, present in the DOM only while it is open. */
export const SCHEDULED_AT_PANEL_SELECTOR = `[data-testid="${SCHEDULED_AT_INPUT_TEST_ID}-input-popover"]`;

interface ScheduledAtFieldProps {
    scheduledAt?: Date;
    onDateChange: (scheduledAt: Date | undefined) => void;
}

/**
 * The optional meeting date and time picker of the plan's date modal.
 */
export const ScheduledAtField = ({ scheduledAt, onDateChange }: ScheduledAtFieldProps) => {
    const { t } = useAmelioTranslations();
    const language = useSelectedAppLanguage();

    return (
        <div className={'flex flex-col gap-2'}>
            <Text weight={'medium'}>{t('thematicMeetings.newMeeting.dateLabel')}</Text>

            <DateInput
                value={scheduledAt}
                onChange={onDateChange}
                showTime
                closeOnTimeSelect
                dateFormat={DATE_FORMATS.DISPLAY_DATE_TIME}
                clearable
                lang={toContentLanguage(language)}
                placeholder={t('thematicMeetings.newMeeting.datePlaceholder')}
                idleBorderClassName={FIELD_BORDER}
                ariaLabel={t('thematicMeetings.newMeeting.dateLabel')}
                dataTestId={SCHEDULED_AT_INPUT_TEST_ID}
            />
        </div>
    );
};
